<template>
	<div class="input-group grow" :class="inputGroupClasses">
		<app-label :field="id ?? name" :inline="inline">{{ label }}</app-label>

		<div :class="[{ 'mt-2': !noMargin }, { 'sm:grow sm:mt-0': inline }]">
			<div :class="wrapperClasses">
				<select
					:id="id ?? name"
					:name="name"
					:aria-label="name"
					:autocomplete="autocomplete"
					:class="selectClasses"
					:value="modelValue"
					:disabled="disabled"
					@change="updateValue">
					<option v-if="placeholder !== false" value="" selected disabled>
						{{ placeholder }}
					</option>

					<option v-for="(option, key) in options" :key="key" :value="option[valueKey]">
						{{ option[labelKey] }}
					</option>
				</select>

				<div
					v-if="error"
					class="pointer-events-none absolute inset-y-0 right-5 flex pr-3 items-center">
					<font-awesome-icon
						icon="fas fa-exclamation-circle"
						class="text-red-600"></font-awesome-icon>
				</div>
			</div>

			<p v-if="error" :id="`${name}-error`" class="mt-2 text-sm text-red-600">
				{{ error }}
			</p>

			<p v-else-if="hint" :id="`${name}-description`" class="mt-2 text-sm text-gray-500">
				{{ hint }}
			</p>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { useFieldClasses } from '@/composables/forms'

	const props = withDefaults(
		defineProps<{
			modelValue?: string
			id?: string
			label?: string
			name: string
			hint?: string
			error?: string
			autocomplete?: string
			placeholder?: string | false
			inline?: boolean
			size?: 'small' | 'medium' | 'large'
			theme?: 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'danger'
			options: Array<any>
			valueKey?: string
			labelKey?: string
			disabled?: boolean
			noMargin?: boolean
		}>(),
		{
			modelValue: undefined,
			id: '',
			label: undefined,
			hint: undefined,
			error: undefined,
			theme: 'primary',
			size: 'medium',
			autocomplete: 'on',
			inline: false,
			disabled: false,
			placeholder: 'Please select...',
			valueKey: 'value',
			labelKey: 'label',
			noMargin: false
		}
	)

	// Styles
	const { wrapperClasses, inputGroupClasses, selectClasses } = useFieldClasses(props)

	// Events
	const emit = defineEmits(['update:modelValue'])
	function updateValue(e: Event) {
		emit('update:modelValue', (e.target as HTMLInputElement).value)
	}
</script>
